import { fork, all } from 'redux-saga/effects';

import * as Maps_Modals from './MapsModals';

export default function* rootSaga() {
  yield all([...Object.values(Maps_Modals)].map(fork));
}
